export default function () {
  const config = {
    namespaced: true,
  };
  return config;
}
